import { httpClient } from '@/core/api/httpClient';
import type {
  BoardViewDto,
  CreateBoardViewPayload,
  UpdateBoardViewPayload,
  CreatedResponse,
} from '../types';
import { mockBoardViews } from './board-views.mock';
import { env } from '@/core/config/env';
import { API_V1 } from '@/core/api/endpoints';

const USE_MOCK = env.VITE_USE_MOCK === 'true';

const boardViewsMock: BoardViewDto[] = [...mockBoardViews];

export const boardViewsService = {
  getByBoard: async (boardId: string, signal?: AbortSignal) => {
    if (USE_MOCK) {
      return Promise.resolve({
        data: boardViewsMock.filter((v) => v.boardId === boardId),
      });
    }
    return httpClient.get<BoardViewDto[]>(`${API_V1}/boards/${boardId}/views`, { signal });
  },

  create: async (boardId: string, data: CreateBoardViewPayload) => {
    if (USE_MOCK) {
      const newView: BoardViewDto = {
        id: `bv-${Date.now()}`,
        boardId,
        name: data.name,
        type: data.type,
        createdById: 'user-1',
        createdAt: new Date().toISOString(),
        config: null,
      };
      boardViewsMock.push(newView);
      return Promise.resolve({ data: { id: newView.id } as CreatedResponse });
    }
    return httpClient.post<CreateBoardViewPayload, CreatedResponse>(
      `${API_V1}/boards/${boardId}/views`,
      data,
    );
  },

  update: async (boardId: string, viewId: string, data: UpdateBoardViewPayload) => {
    if (USE_MOCK) {
      const view = boardViewsMock.find((v) => v.id === viewId && v.boardId === boardId);
      if (view) view.config = data.config;
      return Promise.resolve({ data: undefined as void });
    }
    return httpClient.patch<UpdateBoardViewPayload, void>(
      `${API_V1}/boards/${boardId}/views/${viewId}`,
      data,
    );
  },

  delete: async (boardId: string, viewId: string) => {
    if (USE_MOCK) {
      const idx = boardViewsMock.findIndex((v) => v.id === viewId && v.boardId === boardId);
      if (idx !== -1) boardViewsMock.splice(idx, 1);
      return Promise.resolve({ data: undefined as void });
    }
    return httpClient.delete<void>(`${API_V1}/boards/${boardId}/views/${viewId}`);
  },
};
